import React from 'react';
import UnifiedGallery from '../components/UnifiedGallery';
import useStandardGallery from '../hooks/useStandardGallery';

const VinoPage = () => {
  // Use standardized gallery hook with consistent configuration
  const { getGalleryProps } = useStandardGallery('wine');

  return (
    <div className="page-container-wrapper max-width-default padding-default">
      <div className="page-header">
        <h1>
          <i className="fas fa-wine-glass-alt"></i>
          Wine
        </h1>
        <p>Wine making is a tradition that runs deep in our family. From the vineyards of Italy to our home in Connecticut, the art of creating fine wine has been passed down through generations.</p>
      </div>

      <div className="page-content">
        <div className="section">
          <div className="wine-content">
            <p>
              Wine making is a tradition that runs deep in our family. From the vineyards of Italy to our home in Connecticut, 
              the art of creating fine wine has been passed down through generations.
            </p>
          </div>
        </div>

        {/* Wine Gallery */}
        <div className="section">
          <UnifiedGallery 
            {...getGalleryProps("Wine is in our blood...")}
          />
        </div>
      </div>
    </div>
  );
};

export default VinoPage;